import { configureStore } from '@reduxjs/toolkit';
import { debounce } from 'debounce';
import { BoatDetailsState } from '../features/boatList/BoatDetails';
import boatListReducer from '../features/boatList/boatListSlice';
import { cutover } from './cutover';
import { analyticsMiddleware } from '../services/AnalyticsMiddleware';

const LOCAL_STORAGE_KEY = 'SailingHandicapCalculator';

// convert object to string and store in localStorage
function saveStateToLocalStorage(state: RootState) {
  console.log('store.saveStateToLocalStorage');
  try {
    const serialisedState = JSON.stringify(state);
    localStorage.setItem(LOCAL_STORAGE_KEY, serialisedState);
  } catch (e) {
    console.warn(e);
  }
}

const defaultState: RootState = {
  boatList: {
    baseBoatId: '',
    boatDetailsList: [],
    currentGroupId: '',
    boatGroupList: [],
  },
};

// load string from localStarage and convert into an Object
// invalid output must be undefined
function loadStateFromLocalStorage(): RootState {
  console.log('store.loadStateFromLocalStorage');
  let result: RootState;
  try {
    const serialisedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (serialisedState === null) {
      result = defaultState;
      console.log('store.loadStateFromLocalStorage using default state', result);
    } else {
      result = JSON.parse(serialisedState);
      console.log('store.loadStateFromLocalStorage found state', result);
    }
  } catch (e) {
    console.warn(e);
    result = defaultState;
    console.log('store.loadStateFromLocalStorage using default state due to error', result);
  }
  // TODO do migration activities here
  result = cutover(result);
  return result;
}

export const store = configureStore({
  reducer: {
    boatList: boatListReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(analyticsMiddleware.createMiddleware()),
  preloadedState: loadStateFromLocalStorage(),
});

// here we subscribe to the store changes
store.subscribe(
  debounce(() => {
    saveStateToLocalStorage(store.getState());
  }, 800),
);


export interface RootState {
  boatList: BoatDetailsState;
}
export type AppDispatch = typeof store.dispatch


